import { ConsolePluginFacade } from '../../JWeb/facades/ConsolePluginFacade';

export const shouldCallLogs = (
  isNative: boolean,
  disableBrowserConsoleOnNative: boolean
): { shouldCallNativeLog: boolean; shouldCallBrowserLog: boolean } => {
  const windowJwebConsole = ConsolePluginFacade.getConsolePlugin();
  const isNativeLogPluginMissing = isNative && !windowJwebConsole;
  const shouldCallNativeLog = Boolean(isNative && windowJwebConsole);
  const shouldCallBrowserLog =
    !isNative || isNativeLogPluginMissing || !disableBrowserConsoleOnNative;

  if (isNativeLogPluginMissing) {
    console.warn(
      'JWeb Console Plugin not found. Using default console instead. You may miss this log on some native apps.'
    );
  }

  return { shouldCallNativeLog, shouldCallBrowserLog };
};
